module.exports = __webpack_public_path__ + "static/media/ebbae8ae-2cd5-43e9-be98-ef1f69def547.4164632f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/completion/ebbae8ae-2cd5-43e9-be98-ef1f69def547.png
// module id = 1499
// module chunks = 0